import {
  AdvancedFilterContext,
  QuickSearchFilter,
} from '@helios/generic-components'

export const createFilterContextFromQuickSearch = (
  searchValue: string | undefined,
  filterContext: AdvancedFilterContext,
) => {
  const { quickSearch, ...otherFilters } = filterContext.advancedFilters

  if (quickSearch?.substring === searchValue) {
    return filterContext
  }

  let updatedQuickSearch: QuickSearchFilter | undefined

  if (searchValue) {
    updatedQuickSearch = {
      substring: searchValue,
      substrings: searchValue.split(', '),
    }
  }

  return {
    ...filterContext,
    advancedFilters: { ...otherFilters, quickSearch: updatedQuickSearch },
  } as AdvancedFilterContext
}
